import { FunctionalComponent, h } from "preact"
import { PointsCurrencyContentStyled, PointsStyled } from "./points.style"

export interface PointsProps {
  number: string,
  pointsLabel?: string,
  currency: string,
  color: string
}
export const Points: FunctionalComponent<PointsProps> = ({ number, pointsLabel, color, currency }) => {
  return (
    <PointsStyled color={color}>
      <span className="number">{number}</span>
      <PointsCurrencyContentStyled>
        <span className="points-label">{pointsLabel}</span>
        <span className="currency">{currency}</span>
      </PointsCurrencyContentStyled>
    </PointsStyled>
  )
}